import React, { useReducer } from 'react'
import InvoiceContext from './invoiceContext'
import InvoiceReducer from './invoiceReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_INVOICES,
    GET_SINGLE_INVOICE,
    GET_SINGLE_SELLER_INVOICE,
    GET_INVOICE_DETAILS,
    GET_MULTIPLE_INVOICE,
    GET_CONTENT_INVOICE,
    GET_EMAIL_INVOICE,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './invoiceTypes'

const InvoiceState = (props) => {
    const initialState = {
        all_invoices: {
            records: [],
            totalRecords: 0,
            summary: {},
            setDisp: '',
        },
        single_invoice: {
            invoicerecords: [],
            transactionrecords: [],
            returnTransactions: [],
            appointmentrecord: {},
            locationrecord: {},
            cartvalues: {},
            from: '',
        },
        single_seller_invoice: {
            invoicerecords: [],
            transactionrecords: [],
            returnTransactions: [],
            appointmentrecord: {},
            locationrecord: {},
            cartvalues: {},
            from: '',
        },
        multiple_invoice: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        invoice_details: {
            invoicerecords: [],
            transactionrecords: [],
            appointmentrecord: {},
            locationrecord: {},
            cartvalues: {},
            orderControlLogs: [],
            from: '',
        },
        content_invoice: {
            record: null,
            from: '',
        },
        email_invoice: {
            record: null,
            from: '',
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(InvoiceReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllInvoices = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'invoices', formData, '', 'invoice'),
            ])
            const fromVariable = from ? from : 'Invoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_INVOICES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        summary: res.data.data.responseData.summary,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllInvoicesBoxBids = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'invoicesboxbids', formData, '', 'invoice'),
            ])
            const fromVariable = from ? from : 'Invoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_INVOICES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        summary: res.data.data.responseData.summary,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getSingleInvoice = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'invoice', formData, '', 'user/invoice'),
            ])
            const from = fromVariable ? fromVariable : 'InvoiceManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_INVOICE,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems
                            .length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData
                            .allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        returnTransactions: res.data.data.responseData
                            ?.returnTransactions?.length
                            ? res.data.data.responseData.returnTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData
                            .appointmentDetail
                            ? res.data.data.responseData.appointmentDetail
                            : [],
                        locationrecord: res.data.data.responseData
                            .locationDetail
                            ? res.data.data.responseData.locationDetail
                            : [],
                        cartvalues: res.data.data.responseData.cartValues,
                        invoiceuserrecord: res.data.data.responseData
                            .invoiceUser
                            ? res.data.data.responseData.invoiceUser
                            : [],
                        invoicesellerrecord: res.data.data.responseData
                            .invoiceSeller
                            ? res.data.data.responseData.invoiceSeller
                            : {},
                        invoiceaddressrecord: res.data.data.responseData
                            .invoiceAddress
                            ? res.data.data.responseData.invoiceAddress
                            : [],
                        order_control_logs: res?.data?.data?.responseData
                            ?.order_control_logs
                            ? res?.data?.data?.responseData?.order_control_logs
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleSellerInvoice = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'sellerprdtinvoice',
                    formData,
                    '',
                    'user/invoice'
                ),
            ])
            const from = fromVariable ? fromVariable : 'SellerInvoice'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_SELLER_INVOICE,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems
                            .length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData
                            .allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        returnTransactions: res.data.data.responseData
                            ?.returnTransactions?.length
                            ? res.data.data.responseData.returnTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData
                            .appointmentDetail
                            ? res.data.data.responseData.appointmentDetail
                            : [],
                        locationrecord: res.data.data.responseData
                            .locationDetail
                            ? res.data.data.responseData.locationDetail
                            : [],
                        cartvalues: res.data.data.responseData.cartValues,
                        invoiceuserrecord: res.data.data.responseData
                            .invoiceUser
                            ? res.data.data.responseData.invoiceUser
                            : [],
                        invoicesellerrecord: res.data.data.responseData
                            .invoiceSeller
                            ? res.data.data.responseData.invoiceSeller
                            : {},
                        invoiceaddressrecord: res.data.data.responseData
                            .invoiceAddress
                            ? res.data.data.responseData.invoiceAddress
                            : [],
                        order_control_logs: res?.data?.data?.responseData
                            ?.order_control_logs
                            ? res?.data?.data?.responseData?.order_control_logs
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getMultipleInvoice = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'multipleInvoice',
                    formData,
                    '',
                    'user/invoice'
                ),
            ])
            const from = fromVariable ? fromVariable : 'MultipleInvoice'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_MULTIPLE_INVOICE,
                    payload: {
                        records: res.data.data.responseData.length
                            ? res.data.data.responseData
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getInvoiceDetails = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getInvoiceDetails', formData, '', 'invoice'),
            ])
            const from = fromVariable ? fromVariable : 'InvoiceDetails'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_INVOICE_DETAILS,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems
                            .length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData
                            .allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData
                            .appointmentDetail
                            ? res.data.data.responseData.appointmentDetail
                            : [],
                        locationrecord: res.data.data.responseData
                            .locationDetail
                            ? res.data.data.responseData.locationDetail
                            : [],
                        cartvalues: res.data.data.responseData.cartValues,
                        invoiceuserrecord: res.data.data.responseData
                            .invoiceUser
                            ? res.data.data.responseData.invoiceUser
                            : [],
                        invoiceaddressrecord: res.data.data.responseData
                            .invoiceAddress
                            ? res.data.data.responseData.invoiceAddress
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const changeProductStatus = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'productchange'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const sellerTransactionAction = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'sellerTransaction'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'sellerTransactionAction',
                    formData,
                    '',
                    'invoice'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateInvoice = async (formData) => {
        try {
            const from = 'invoiceupdate'
            const [res] = await Promise.all([
                apiCall('post', 'update_invoice', formData, '', 'user/invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const invoiceAction = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'invoiceAction'

            const [res] = await Promise.all([
                apiCall('post', 'invoiceAction', formData, '', 'invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const generateInvoicePDF = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'generateInvoicePDF'

            const [res] = await Promise.all([
                apiCall('post', 'generateInvoicePDF', formData, '', 'invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const sendInvoiceEmail = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'sendInvoiceEmail'

            const [res] = await Promise.all([
                apiCall('post', 'sendInvoiceEmail', formData, '', 'invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const retrieveInvoiceHTML = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'retrieveInvoiceHTML'

            const [res] = await Promise.all([
                apiCall('post', 'retrieveInvoiceHTML', formData, '', 'invoice'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CONTENT_INVOICE,
                    payload: {
                        record: res.data.data?.responseData?.record || null,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const retrieveInvoiceEmail = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'retrieveInvoiceEmail'

            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'retrieveInvoiceEmail',
                    formData,
                    '',
                    'invoice'
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_EMAIL_INVOICE,
                    payload: {
                        record: res.data.data?.responseData?.record || null,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <InvoiceContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                all_invoices: state.all_invoices,
                responseStatus: state.responseStatus,
                single_invoice: state.single_invoice,
                single_seller_invoice: state.single_seller_invoice,
                invoice_details: state.invoice_details,
                multiple_invoice: state.multiple_invoice,
                content_invoice: state.content_invoice,
                email_invoice: state.email_invoice,
                clearResponse,
                getMultipleInvoice,
                getAllInvoices,
                sellerTransactionAction,
                getAllInvoicesBoxBids,
                changeProductStatus,
                getInvoiceDetails,
                getSingleInvoice,
                getSingleSellerInvoice,
                updateInvoice,
                generateInvoicePDF,
                invoiceAction,
                sendInvoiceEmail,
                retrieveInvoiceHTML,
                retrieveInvoiceEmail,
            }}
        >
            {props.children}
        </InvoiceContext.Provider>
    )
}

export default InvoiceState
